"use client";

import React from "react";
import { cn, withRef } from "@udecode/cn";
import { PlateElement } from "@udecode/plate-common";
import { blockquoteStyles } from "@/components/cms/ContentEditor/config/style.config";

export const BlockquoteElement = withRef<typeof PlateElement>(
	({ className, children, ...props }, ref) => {
		return (
			<PlateElement
				ref={ref}
				asChild
				className={cn(blockquoteStyles, className)}
				{...props}
			>
				<blockquote>{children}</blockquote>
			</PlateElement>
		);
	}
);
